import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApplyApi } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../ApplicationInsights';

const applyApi = new ApplyApi(applicationInsights);

enum QueryKeys {
    AuthorizedUsers = 'authorizedUsers',
    AssignedUsers = 'assignedUsers',
}

export function useAuthorizedUsersQuery() {
    return useQuery({
        queryKey: [QueryKeys.AuthorizedUsers],
        queryFn: async () => {
            const response = await applyApi.getAuthorizedUsers();
            if (response.statusCode !== 200 || !response.result) {
                const errorMsg = response.errors?.length > 0 ? response.errors.join(', ') : 'Failed to load user data';
                throw new Error(errorMsg);
            }
            return response.result;
        },
    });
}

export function useAssignedUsersQuery() {
    return useQuery({
        queryKey: [QueryKeys.AssignedUsers],
        queryFn: async () => {
            const response = await applyApi.getAssignedUsers();
            if (response.statusCode !== 200 || !response.result) {
                const errorMsg =
                    response.errors?.length > 0 ? response.errors.join(', ') : 'Failed to load assigned user data';
                throw new Error(errorMsg);
            }
            return response.result;
        },
    });
}

export function useRefreshUserManagement() {
    const queryClient = useQueryClient();
    return () => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.AuthorizedUsers] });
        queryClient.invalidateQueries({ queryKey: [QueryKeys.AssignedUsers] });
    };
}
